import React from 'react';
import { Image } from 'antd';
import { ImageOff } from 'lucide-react';

/** Uniform thumbnail grid with a shared preview (click to enlarge / browse). */
export default function ImageGrid({ images = [], getImageUrl, alt, height = 96, columns = 'grid-cols-3' }) {
    return (
        <Image.PreviewGroup>
            <div className={`grid gap-2 ${columns}`}>
                {images.map((img, idx) => (
                    <Image
                        key={idx}
                        src={getImageUrl(img)}
                        alt={`${alt} ${idx + 1}`}
                        width="100%"
                        height={height}
                        className="object-cover rounded-lg"
                        rootClassName="block overflow-hidden rounded-lg border border-surface-200 bg-surface-50"
                        fallback="/not-found.png"
                    />
                ))}
            </div>
        </Image.PreviewGroup>
    );
}

/** Small placeholder used where a gallery has no photos. */
export function NoImages({ label, height }) {
    return (
        <div
            className="flex flex-col items-center justify-center gap-1 rounded-lg border border-dashed border-surface-200 bg-surface-50 px-3 py-4 text-center text-xs text-surface-400"
            style={height ? { height } : undefined}>
            <ImageOff className="text-base" />
            {label}
        </div>
    );
}
